import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Phone } from 'lucide-react';
import SEO from '../components/SEO';
import CrisisSupport from '../components/CrisisSupport';
import ScrollIndicator from '../components/ScrollIndicator';
import './AssessmentPage.css';

const Therapy = () => {
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) entry.target.classList.add('revealed');
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
    const els = document.querySelectorAll('.scroll-reveal');
    els.forEach((el) => observer.observe(el));
    return () => els.forEach((el) => observer.unobserve(el));
  }, []);

  return (
    <div className="page-assessment" data-testid="therapy-page">
      <SEO
        title="Therapy for Neurodivergent Young People & Adults | Clinical Minds Psychology"
        description="Warm, neuroaffirming therapy with a focus on neurodivergent teens and adults. Coffs Harbour and telehealth. Medicare rebates available."
        canonicalUrl="https://www.clinicalminds.net/therapy"
      />
      <ScrollIndicator />

      <section id="main-content" className="interior-hero" data-testid="page-hero">
        <div className="container">
          <span className="section-label">Therapy</span>
          <h1 className="heading-hero">Therapy</h1>
          <p className="hero-subline">Compassionate, practical psychological support</p>
        </div>
      </section>

      <section className="assess-section scroll-reveal">
        <div className="container assess-narrow">
          <div className="assess-body">
            <p className="body-medium">
              I provide individual therapy as a standalone service. My approach is warm, practical and strengths-based, focused on understanding your experience and building skills that work for your life.
            </p>
          </div>
        </div>
      </section>

      <section className="assess-section assess-alt scroll-reveal">
        <div className="container assess-narrow">
          <span className="section-label">Areas of Focus</span>
          <h2 className="heading-1">Main areas of interest</h2>
          <div className="assess-body">
            <ul>
              <li><strong>Neurodiversity:</strong> therapy for neurodivergent young people and adults, including identity, burnout and navigating school, work and relationships</li>
              <li><strong>Teens</strong></li>
              <li><strong>Substance use and addiction:</strong> an area Lachlan has researched and <Link to="/about#publications" className="assess-link">published on in peer-reviewed journals</Link></li>
            </ul>
            <p className="body-medium" style={{ marginTop: '1.5rem' }}>
              I also work with: anxiety and social anxiety, depression, trauma, grief and loss, phobias, relationships, identity and self-esteem.
            </p>
          </div>
        </div>
      </section>

      <section className="assess-section scroll-reveal">
        <div className="container assess-narrow">
          <span className="section-label">The Process</span>
          <h2 className="heading-1">How it works</h2>
          <div className="assess-body">
            <p className="body-medium">
              Therapy is available face-to-face in Coffs Harbour and via Telehealth. Medicare rebates are available with a Mental Health Treatment Plan from your GP. Sessions are typically 50 minutes.
            </p>
            <p className="body-medium" style={{ marginTop: '1rem' }}>
              <Link to="/fees" className="assess-link">View fee information →</Link>
            </p>
          </div>
        </div>
      </section>

      <section className="assess-cta-section" data-testid="therapy-cta">
        <div className="container">
          <div className="assess-cta-card">
            <h2 className="heading-2">Ready to find out more?</h2>
            <p className="body-large">Send us an enquiry or give us a call.</p>
            <div className="assess-cta-buttons">
              <Link to="/contact?enquiry=therapy" className="btn-primary" data-testid="therapy-enquiry-btn">
                Make an Enquiry
              </Link>
              <a href="tel:0266002710" className="assess-phone-cta">
                <Phone size={18} /> 02 6600 2710
              </a>
            </div>
          </div>
        </div>
      </section>

      <CrisisSupport />
    </div>
  );
};

export default Therapy;
